import PropTypes from 'prop-types';
import styled from 'styled-components';

const LayoutContent = styled.div`
  clear: both;
  width: 100%;
  margin: 0;
  padding: 0;

  &:before,
  &:after {
    content: ' ';
    display: table;
  }
`;

const LayoutWrapperStyled = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;

  @media only screen and (min-width: 600px) and (max-width: 1024px),
    only screen and (min-height: 600px) and (max-height: 1024px) and (orientation: landscape) {
    & > ${LayoutContent} {
      width: 100%;
      max-width: 100%;
      margin: 0 auto;
    }
  }

  @media only screen and (min-width: 1025px) {
    & > ${LayoutContent} {
      max-width: 1240px;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 1239px) and (min-width: 1025px) {
    & > ${LayoutContent} {
      width: 978px;
    }
  }

  #content {
    transform: none;
  } 
`;

const LayoutWrapper = ({ children, wrapperName }) => (
  <LayoutWrapperStyled className={'LayoutWrapper'} data-element={wrapperName}>
    <LayoutContent className={'layout-content'}>{children}</LayoutContent>
  </LayoutWrapperStyled>
);

LayoutWrapper.displayName = 'LayoutWrapper';

LayoutWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  wrapperName: PropTypes.string.isRequired
};

export default LayoutWrapper;
